import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import { myroutes } from "../../routes/webroute";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import $ from "jquery"
import PeriodiquesService from "../../services/PeriodiquesService";
import EditeursService from "../../services/EditeursService";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useSelector } from "react-redux";

export default function EditPeriodiques() {

    //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()
    const [validationError, setValidationError] = useState({})
    const location = useLocation()
    const token = useSelector(state => state.auth.token)

    const animatedComponents = makeAnimated();
    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [titre_periodicite, setTitrePeriodique] = useState('')
    const [montant_periodique, setMontantPeriodique] = useState('')
    const [montant_abonnement, setMontantAbonnement] = useState('')
    //const [editeur_id, setEditeur] = useState('')
    const [editeurs, setListeEditeurs] = useState([]) //liste des editeurs disponible dans la base
    const [selectedEditeur, setSelectedEditeur] = useState([]); //get value of select


    ///Save form data
    const handleSubmit = async (event) => {
        event.preventDefault()
        //Recupérer uniquement les id
        var editeur_id = selectedEditeur.value //.map((option) => option.value)
        let form = {
            titre_periodicite, montant_periodique, montant_abonnement, editeur_id
        }

        await PeriodiquesService.update(location.state.id, form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                    showConfirmButton: false,
                    timer: 2000
                })
                setValidationError(response.data.erreur)
            } else {            
                //redirection sur index
                navigate(myroutes.periodiques_index)
                 Swal.fire({
                    icon: "success",
                    text: response.data.message,
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                    background : "green",
                    iconColor: "white",
                    color: "white"
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    //get edit data
    const edit = async () => {
        await PeriodiquesService.edit(location.state.id,token).then((response) => {
            const data = response.data.periodique
            setTitrePeriodique(data.titre_periodicite)
            setMontantPeriodique(data.montant_periodique)
            setMontantAbonnement(data.montant_abonnement)
            setSelectedEditeur(data.editeur_id)

        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            setValidationError(error.message)
        });
    }


    const getEditeurs = async () => {
        await EditeursService.index().then((response) => {
            setListeEditeurs(response.data.liste_editeurs)
            //console.log(response.data.roles)
        }).catch(error => {
            console.log(error.message)
        });
    }

    const editeurOptions = editeurs.map((option) => ({
        value: option.id,
        label: option.raison_sociale
    }))

    const handleEditeurSelection = (selectedOptions) => {
        setSelectedEditeur(selectedOptions);
        //console.log(selectedEditeur.value)
    };

    useEffect(() => {
        edit();
        getEditeurs()
        $("#submenu-2").addClass("show")
    }, [])

    //##########################/// END METHODES ##########################///

    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.periodiques_index} >Periodiques</Link></li>
                                        <li className="breadcrumb-item active">Modification Periodique </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Modification </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-2 mx-3">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }} onSubmit={handleSubmit}>

                            <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre Periodicite <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setTitrePeriodique(e.target.value)}
                                                value={titre_periodicite}
                                                placeholder=""
                                                name="titre_periodicite"
                                                aria-label="titre_periodicite"
                                                maxLength={255}
                                                minLength={3}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Editeurs <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Select
                                                options={editeurOptions}
                                                onChange={handleEditeurSelection}
                                                value={selectedEditeur}
                                                components={animatedComponents}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Montant périodiques <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setMontantPeriodique(e.target.value)}
                                                value={montant_periodique}
                                                placeholder=""
                                                name="montant_periodique"
                                                aria-label="montant_periodique"
                                                max={999999}
                                                min={10}
                                                type="number"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Montant abonnement <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setMontantAbonnement(e.target.value)}
                                                value={montant_abonnement}
                                                placeholder=""
                                                name="montant_abonnement"
                                                aria-label="montant_abonnement"
                                                max={999999}
                                                min={10}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>


                                <Button type="submit" variant="primary">Enregistrer</Button>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}